module.exports = __webpack_public_path__ + "static/bird-avatar-337453bd576505a15e72654c395f9333.png";